export const retailerLogos = {
  R3: "8ahuit.png",
  R6: "a2pas.png",
  R14: "aldi.png",
  R30: "atac.png",
  R41: "auchan.png",
  R42: "auchancity.png",
  R43: "auchansupermarche.png",
  R61: "bi1.png",
  R62: "bigmat.png",
  R68: "boulanger.png",
  R77: "bricodepot.png",
  R78: "bricoeleclerc.png",
  R80: "bricoman.png",
  R81: "bricomarche.png",
  R82: "bricor.png",
  R83: "bricorama.png",
  R85: "but.png",
  R91: "carrefour.png",
  R92: "carrefourbio.png",
  R93: "carrefourbonapp.png",
  R94: "carrefourcity.png",
  R95: "carrefourcontact.png",
  R96: "carrefourexpress.png",
  R97: "carrefourmarket.png",
  R98: "carrefourmontagne.png",
  R99: "carrefour.png",
  R100: "carrefour.png",
  R106: "casino.png",
  R107: "casino.png",
  R108: "casinoshop.png",
  R111: "castorama.png",
  R120: "coccimarket.png",
  R129: "conforama.png",
  //R130: "connexion.png",
  R135: "cora.png",
  R139: "darty.png",
  R140: "darty.png",
  R143: "dia.png",
  R160: "electrodepot.png",
  //R181: "expert.png",
  R186: "fnac.png",
  R190: "franprix.png",
  R192: "franprixnano.png",
  R194: "g20.png",
  R203: "geant.png",
  R204: "geant.png",
  R205: "gedimat.png",
  R207: "gifi.png",
  R209: "gitem.png",
  R218: "hypercasino.png",
  R226: "inter.png",
  R242: "plateformedubatiment.png",
  R261: "leaderprice.png",
  R263: "leclerc.png",
  R264: "leclerc.png",
  R265: "leclercdrive.png",
  R266: "leclercexpress.png",
  R270: "leroymerlin.png",
  R283: "lidl.png",
  R298: "match.png",
  R305: "metro.png",
  R308: "migros.png",
  R313: "monopdaily.png",
  R316: "monoprix.png",
  R320: "mrbricolage.png",
  R323: "netto.png",
  R324: "norauto.png",
  R328: "officedepot.png",
  R334: "paraauchan.png",
  R335: "paracarrefour.png",
  R336: "paraleclerc.png",
  R337: "paramonoprix.png",
  //R339: "parapharmacie.png",
  R345: "petitcasino.png",
  R347: "pharmacie.png",
  R356: "pointp.png",
  R358: "pointvert.png",
  R362: "pro&cie.png",
  R371: "pulsat.png",
  //R378: "record.png",
  R392: "shop.png",
  R394: "simplymarket.png",
  R403: "spar.png",
  R460: "truffaut.png",
  R461: "u.png",
  R478: "ldlc.png",
  //R479: "lamaison.png",
  R480: "midica.png",
  R481: "probox.png",
  R482: "bricolex.png",
  //R483: "briquin.png",
  R484: "lapeyre.png",
  R485: "mobalpa.png",
  //R486: "cuisineindependants.png",
  R487: "cuisineplus.png",
  R488: "cuisinella.png",
  R489: "cuisinesreferences.png",
  R490: "findis.png",
  R491: "ixina.png",
  R492: "perene.png",
  R493: "schmidt.png",
  R494: "socooc.png",
  R495: "totalconsortium.png",
  //R496: "prospection.png",
  R497: "cashngo.png",
  R498: "midica.png",
  R499: "schiever.png"
};



// WEBPACK FOOTER //
// src/containers/activite/map/retailerLogos.js